import { folderSchemas } from "@redotech/redo-views-common/folders";
import { viewWithIdSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const saveOrderTrackingViewsAndFolders = {
  name: "saveOrderTrackingViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas["order-tracking-shipments"]),
    views: z.array(viewWithIdSchemas["order-tracking-shipments"]),
  }),
  output: zNull(),
};
